import { Component, Input } from '@angular/core';

@Component({
  selector: 'form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.sass'],
})
export class FormErrorComponent {

  @Input() name: string;

  @Input() model: any;

}
